// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `boxx-custom-modal {
  --boxx-modal-header-background: var(--ion-color-medium, grey);
}

ion-avatar {
  width: 10px;
  height: 10px;
  border: none;
}

.local {
  background: #A39127;
}

.mobile {
  background: #7D7CDF;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/state-picker/state-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,6DAAA;AACF;;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACA;;AAEA;EACA,mBAAA;AACA;;AAEA;EACA,mBAAA;AACA","sourcesContent":["boxx-custom-modal{\n  --boxx-modal-header-background: var(--ion-color-medium, grey);\n}\n\nion-avatar{\nwidth: 10px;\nheight: 10px;\nborder: none;\n}\n\n.local{\nbackground: #A39127;\n}\n\n.mobile{\nbackground: #7D7CDF;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
